export const toText = (value: any): string => {
  if (value == null) return '';
  if (typeof value === 'object' && 'String' in value) return value.String ?? '';
  return String(value);
};

export const isValidUrl = (url: string) => {
  if (url === '' || url === null || url === undefined) {
    return true;
  }

  try {
    new URL(url);
    return true;
  } catch (error) {
    return false;
  }
};

export const isValidEmail = (email: string): boolean => {
  // Simple regex for email validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; 
  return emailRegex.test(email);
};

export const APPLICANT_STATUSES = [
  "OpenCV",
  "Short Listed",
  "Interview Called",
  "Interviewed",
  "Test Called",
  "Tested",
  "Technical Interview Called",
  "Technical Interviewed",
  "Client Interview Called",
  "Client Interviewed",
  "Final Interview Called",
  "Final Interviewed",
  "Selected",
  "Offered",
  "Joined",
  "Rejected",
  "Offer Rejected",
  "No Vacancy",
] as const;

export const STATUS_CONFIG = {
  "OpenCV": { label: 'Open CV', color: '#5656FF', backgroundColor: '#5656FF1A' },
  "Short Listed": { label: 'Shortlisted', color: '#E7B317', backgroundColor: '#FBB32C1A' },
  "Interview Called": { label: 'Interview Called', color: '#702DFF', backgroundColor: '#702DFF1A' },
  "Interviewed": { label: 'Interviewed', color: '#3E217D', backgroundColor: '#3E217D1A' },
  "Test Called": { label: 'Test Called', color: '#03BCC2', backgroundColor: '#03BCC21A' },
  "Tested": { label: 'Tested', color: '#00839E', backgroundColor: '#00839E1A' },
  "Technical Interview Called": { label: 'Technical Interview Called', color: '#BE0BAA', backgroundColor: '#BE0BAA1A' },
  "Technical Interviewed": { label: 'Technical Interviewed', color: '#870578', backgroundColor: '#8705781A' },
  "Client Interview Called": { label: 'Client Interview Called', color: '#030099', backgroundColor: '#0300991A' },
  "Client Interviewed": { label: 'Client Interviewed', color: '#040268', backgroundColor: '#0402681A' },
  "Final Interview Called": { label: 'Final Interview Called', color: '#BDBD00', backgroundColor: '#BDBD001A' },
  "Final Interviewed": { label: 'Final Interviewed', color: '#999900', backgroundColor: '#9999001A' },
  "Selected": { label: 'Selected', color: '#937AFF', backgroundColor: '#937AFF1A' },
  "Offered": { label: 'Offered', color: '#528900', backgroundColor: '#5289001A' },
  "Joined": { label: 'Joined', color: '#528900', backgroundColor: '#5289001A' },
  "Rejected": { label: 'Rejected', color: '#E9004A', backgroundColor: '#E9004A1A' },
  "Offer Rejected": { label: 'Offer Rejected', color: '#E9004A', backgroundColor: '#E9004A1A' },
  "No Vacancy": { label: 'No Vacancy', color: '#9C9C9C', backgroundColor: '#9C9C9C1A' }
};
